import { LitecoinWalletAdapter, SignPsbtLtcOptions } from '../types';

declare global {
  interface Window {
    litescribe: {
      requestAccounts: () => Promise<string[]>;
      getAccounts: () => Promise<string[]>;
      getPublicKey: () => Promise<string>;
      signPsbt: (psbt: string, options?: SignPsbtLtcOptions) => Promise<string>;
    };
  }
}

export class LitescribeAdapter implements LitecoinWalletAdapter {
  name = 'Litescribe';
  icon = '/wallets/litescribe.png';
  link = 'https://litescribe.io/';
  isConnected = false;
  address: string | null = null;

  openLinkIfNotReady() {
    if (!window.litescribe) {
      window.open(this.link, '_blank');
      return;
    }
  }

  async connect() {
    this.openLinkIfNotReady();
    const accounts = await window.litescribe.requestAccounts();
    this.isConnected = true;
    this.address = accounts[0];
  }
  disconnect() {
    this.isConnected = false;
    this.address = null;
  }

  async getPublicKey() {
    this.openLinkIfNotReady();
    return window.litescribe.getPublicKey();
  }

  async signPsbt(psbt: string, options?: SignPsbtLtcOptions) {
    return window.litescribe.signPsbt(psbt, options);
  }
}
